export default "__VITE_PUBLIC_ASSET__cba90a45__"